import React, { useEffect, useState } from 'react';
import { useRibbonContext } from '@dataswift/shared';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import './Signup.scss';

import ComputerImage from '../../assets/computer.png';
import SignUpForm from './SignupForm';
import { useAuthRedirect, useDataswiftNotification } from '../../helpers/customHooks';
import { getParameterByName } from '../../helpers/window-helper';
import { useThemeContext } from '../../styles/Provider';
import NavHeader from '../../components/NavHeader/NavHeader';
import useStyles from './styles';

type SignupPageProps = {
  path?: string;
  default?: boolean;
};

export const useSignupNotification = (manual: boolean = false) => {
  const { openRibbon } = useRibbonContext();

  useEffect(() => {
    if (getParameterByName('token')) {
      openRibbon({
        message: 'Please fill out the fields below to complete your sign up.',
        manual,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const SignupPage: React.FC<SignupPageProps> = () => {
  const largeScreen = useMediaQuery('(min-width: 1441px)');
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);
  const ribbon = useDataswiftNotification(true);
  useSignupNotification(true);
  const loggedIn = useAuthRedirect();
  const classes = useStyles();

  const { setTheme } = useThemeContext();

  useEffect(() => {
    const prefersLight = window.matchMedia?.('(prefers-color-scheme: light)').matches;
    if (prefersLight) setTheme('light');
  }, [setTheme]);

  if (loggedIn) return null;

  const onPageClick = () => {
    if (navDrawerOpen) setNavDrawerOpen(false);
  };

  return (
    <Grid container className={classes.signup} direction="column">
      <Grid item>
        <NavHeader
          drawerOpen={navDrawerOpen}
          handleDrawerToggle={() => setNavDrawerOpen(!navDrawerOpen)}
        />
      </Grid>

      {ribbon}

      <Grid
        container
        justifyContent={largeScreen ? 'space-between' : 'center'}
        className={`${navDrawerOpen ? 'blurred' : ''}`}
        onClick={onPageClick}
        style={{ paddingTop: '70px' }}
      >
        <Grid
          container
          className={classes.signupDetails}
          direction={largeScreen ? 'column-reverse' : 'row'}
          justifyContent="center"
          alignItems={largeScreen ? 'center' : 'flex-start'}
        >
          <Grid item>
            <img className={classes.signupImage} src={ComputerImage} alt="Computer" />
          </Grid>
          <Grid item>
            <Typography variant="subtitle1" className={classes.titleText}>
              We&apos;re excited that you want to build with us!
            </Typography>
            <Typography>
              As well as a Dataswift Personal Data Account that you can use here and in any
              application that is secured by a Dataswift Personal Data Account, you will be given a
              testing Personal Data Account that you can safely use with your apps for development
              and testing.
            </Typography>
          </Grid>
        </Grid>

        <Grid item className={classes.card} xs={11} sm={9} md={5} lg={5}>
          <Typography variant="h1">Sign up for your Developer account</Typography>

          <SignUpForm />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SignupPage;
